import * as React from 'react';
export default function getRanges({ prefixCls, components = {}, needConfirmButton, onNow, onOk, okDisabled, showNow, locale, }) {
    let presetNode;
    let okNode;
    if (needConfirmButton) {
        const Button = (components.button || 'button');
        if (onNow && !presetNode && showNow !== false) {
            presetNode = (<li className={`${prefixCls}-now`}>
                    <a className={`${prefixCls}-now-btn`} onClick={onNow}>
                        {locale.now}
                    </a>
                </li>);
        }
        okNode = needConfirmButton && (<li className={`${prefixCls}-ok`}>
                <Button disabled={okDisabled} onClick={onOk}>
                    {locale.ok}
                </Button>
            </li>);
    }
    if (!presetNode && !okNode) {
        return null;
    }
    return (<ul className={`${prefixCls}-ranges`}>
            {presetNode}
            {okNode}
        </ul>);
}
